<template>
	<div class="full" style="position: relative;height: 344px;" id="totalinvoiceIndexChart"></div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	import * as echarts from 'echarts';
	export default {
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				chart: null,

			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			createChart() {
				this.$api.invoice.staticsyear().then((res)=>{
					let data = res.data
					let seriesindata = []
					let outgroup = this.$Lodash.groupBy(data, 'companyname')
					// console.log(outgroup)
					// return
					for (let i in outgroup) {
						let outamount = this.$Lodash.sumBy(outgroup[i], (item) => {
							return item.outamount ? parseFloat(item.outamount) : 0
						})
						outgroup[i] = outamount.toFixed(2)
					}
					let seriesoutdata = this.$Lodash.values(outgroup)
					let xdata = this.$Lodash.keys(outgroup)
			
					xdata.forEach((item)=>{
						seriesindata.push(outgroup[item])
					})
					let series = [{
						name: '销项金额',
						type: 'bar',
						label: {
							show: false,
							position: 'top'
						},
						emphasis: {
							focus: 'series'
						},
						tooltip: {
							formatter: () => {
								return '0'
							}
						},
						data: seriesoutdata
					},{
						name: '限额',
						type: 'line',
						label: {
							show: false,
							position: 'top'
						},
						emphasis: {
							focus: 'series'
						},
						tooltip: {
							formatter: () => {
								return '0'
							}
						},
						data: seriesoutdata.map(()=>{
							return 4000000
						})
					}]
					
					if (this.chart) {
						this.chart.clear()
					} else {
						this.chart = echarts.init(document.getElementById('totalinvoiceIndexChart'))
					}
					this.chart.setOption({
						title: {
							show:true,
							text: res.date.join('~'),
							textStyle: {
								fontSize: 14
							}
						},
						series: series,
						xAxis: {
							type: 'category',
							data: xdata
						},
						yAxis: {
							type: 'value'
						},
						grid: {
							left: '3%',
							right: '4%',
							bottom: '3%',
							containLabel: true
						},
						tooltip: {
							trigger: 'axis',
							axisPointer: {
								type: 'shadow'
							}
						},
						toolbox: {
							show: false,
							orient: 'vertical',
							left: 'right',
							top: 'center',
							feature: {
								mark: {
									show: true
								},
								dataView: {
									show: true,
									readOnly: false
								},
								magicType: {
									show: true,
									type: ['line', 'bar', 'stack']
								},
								restore: {
									show: false
								},
								saveAsImage: {
									show: true
								}
							}
						}
					})
				})
				
				
			}
		},
		components: {

		}
	}
</script>